import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY

// Custom fetch with smart timeout using AbortController
// Storage uploads (large files like .glb models) get 2 minutes
// Regular API calls get 12 seconds to prevent hangs on slow networks
const fetchWithTimeout = (url, options = {}) => {
    const isUpload = options.method === 'POST' && url.includes('/storage/')
    const timeout = isUpload ? 120000 : 12000

    const controller = new AbortController()
    const timeoutId = setTimeout(() => controller.abort(), timeout)

    return fetch(url, {
        ...options,
        signal: controller.signal,
    }).finally(() => clearTimeout(timeoutId))
}

export const supabase = createClient(supabaseUrl, supabaseKey, {
    global: {
        fetch: fetchWithTimeout,
    },
})